import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BankAccount\DeleteBankAccountController::deleteMethod
* @see app/Http/Controllers/BankAccount/DeleteBankAccountController.php
* @route '/api/bank-account/{bank_account}'
*/
export const deleteMethod = (args: { bank_account: string | number | { id: string | number } } | [bank_account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/bank-account/{bank_account}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\BankAccount\DeleteBankAccountController::deleteMethod
* @see app/Http/Controllers/BankAccount/DeleteBankAccountController.php
* @route '/api/bank-account/{bank_account}'
*/
deleteMethod.url = (args: { bank_account: string | number | { id: string | number } } | [bank_account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { bank_account: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { bank_account: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            bank_account: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        bank_account: typeof args.bank_account === 'object'
        ? args.bank_account.id
        : args.bank_account,
    }

    return deleteMethod.definition.url
            .replace('{bank_account}', parsedArgs.bank_account.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BankAccount\DeleteBankAccountController::deleteMethod
* @see app/Http/Controllers/BankAccount/DeleteBankAccountController.php
* @route '/api/bank-account/{bank_account}'
*/
deleteMethod.delete = (args: { bank_account: string | number | { id: string | number } } | [bank_account: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\BankAccount\DeleteBankAccountController::undo
* @see app/Http/Controllers/BankAccount/DeleteBankAccountController.php
* @route '/api/bank-account/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/bank-account/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BankAccount\DeleteBankAccountController::undo
* @see app/Http/Controllers/BankAccount/DeleteBankAccountController.php
* @route '/api/bank-account/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\BankAccount\DeleteBankAccountController::undo
* @see app/Http/Controllers/BankAccount/DeleteBankAccountController.php
* @route '/api/bank-account/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BankAccount\DeleteBankAccountController::undo
* @see app/Http/Controllers/BankAccount/DeleteBankAccountController.php
* @route '/api/bank-account/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteBankAccountController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteBankAccountController